const o = /* @__PURE__ */ Symbol("popper"), p = /* @__PURE__ */ Symbol("popperContent");
export {
  p as POPPER_CONTENT_INJECTION_KEY,
  o as POPPER_INJECTION_KEY
};
